// extracted by mini-css-extract-plugin
module.exports = {"dot":"LoadingDots_dot__WyXVg","dot1":"LoadingDots_dot1__Fy1SH","loading":"LoadingDots_loading__Ure1t","dot2":"LoadingDots_dot2__FlPL4","dot3":"LoadingDots_dot3__b8XI1"};